(function () {
  'use strict';

  var MOCKUP_SET_STORAGE_KEY = 'havjoy_mockup_sets_v1';
  var variantReplacementBusy = false;
  function cartRoot() { return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'; }
  function cartSections() { return ['cart-drawer', 'main-cart-items', 'main-cart-footer', 'cart-icon-bubble', 'havjoy-sticky-checkout']; }

  function normalizeMockupVariantName(value) {
    return String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' ');
  }

  function readStoredMockupSets() {
    try {
      var value = JSON.parse(window.localStorage.getItem(MOCKUP_SET_STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function findStoredMockup(currentUrl, productType, color) {
    var normalizedType = normalizeMockupVariantName(productType);
    var matchedSet = readStoredMockupSets().find(function (item) {
      return item && Array.isArray(item.urls) && item.urls.indexOf(currentUrl) !== -1;
    });
    var normalizedColor = normalizeMockupVariantName(color);
    var key = normalizedType + (normalizedColor ? ' / ' + normalizedColor : '');
    var variants = matchedSet && matchedSet.variants || {};
    // Old unqualified cache entries do not identify a garment color.
    // Keep them usable only when the product has no Color option.
    return {
      url: typeof variants[key] === 'string' ? variants[key] : ''
    };
  }

  function announceCartUpdate(message) {
    var liveRegion = document.getElementById('CartDrawer-LiveRegionText');
    if (liveRegion) liveRegion.textContent = message || '';
  }

  function closestAction(event) {
    return event.target.closest('[data-action]');
  }

  function getLineCard(target) {
    return target.closest('[data-item-key]');
  }

  function getQtyFromCard(card) {
    var qtyEl = card && card.querySelector('[data-qty-display]');
    return qtyEl ? parseInt(qtyEl.textContent || '0', 10) : 0;
  }

  function syncSummaryDetails() {
    document.querySelectorAll('[data-cart-summary-details]').forEach(function (details) {
      details.open = false;
    });
  }

  function updateStickyCheckout(sectionHtml, itemCount) {
    var currentBar = document.getElementById('havjoy-sticky-checkout');
    if (!currentBar) return;

    var nextBar = null;
    if (sectionHtml) {
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      nextBar = doc.getElementById('havjoy-sticky-checkout');
    }

    var nextItemCount = typeof itemCount === 'number'
      ? itemCount
      : Number(nextBar && nextBar.dataset.itemCount || 0);
    currentBar.dataset.itemCount = String(nextItemCount);

    var nextTotal = nextBar && nextBar.querySelector('.havjoy-sticky-checkout__total');
    var currentTotal = currentBar.querySelector('.havjoy-sticky-checkout__total');
    if (nextTotal && currentTotal) currentTotal.textContent = nextTotal.textContent.trim();

    var isVisible = nextItemCount > 0;
    currentBar.classList.toggle('is-visible', isVisible);
    currentBar.setAttribute('aria-hidden', String(!isVisible));
  }

  function updateCartIcon(sectionHtml, itemCount) {
    var currentIcon = document.getElementById('cart-icon-bubble');
    if (!currentIcon) return;

    if (sectionHtml) {
      var iconDoc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var sectionRoot = iconDoc.getElementById('shopify-section-cart-icon-bubble') ||
        iconDoc.querySelector('[id$="__cart-icon-bubble"]');
      var nextMarkup = sectionRoot ? sectionRoot.innerHTML : iconDoc.body.innerHTML;
      if (nextMarkup.trim()) currentIcon.innerHTML = nextMarkup;
    }

    // The cart-icon-bubble section renders only the icon contents, not the header link.
    // Always clear a stale badge when Shopify's authoritative cart state is empty.
    if (itemCount === 0) {
      currentIcon.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
        bubble.remove();
      });
    }
  }

  function renderSections(sections, cartState) {
    if (!sections) return Promise.resolve();

    return Promise.resolve().then(function () {
      var parser = new DOMParser();
      var cartDrawer = document.querySelector('cart-drawer');
      var itemCount = cartState && typeof cartState.item_count === 'number'
        ? cartState.item_count
        : undefined;

      if (sections['cart-drawer'] && cartDrawer) {
        var drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
        var nextCartDrawer = drawerDoc.querySelector('cart-drawer');
        var nextCartDrawerInner = drawerDoc.querySelector('#CartDrawer');
        var currentCartDrawerInner = document.getElementById('CartDrawer');

        if (nextCartDrawer) {
          cartDrawer.classList.toggle('is-empty', nextCartDrawer.classList.contains('is-empty'));
        }

        if (nextCartDrawerInner && currentCartDrawerInner) {
          currentCartDrawerInner.innerHTML = nextCartDrawerInner.innerHTML;
        }

        var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof cartDrawer.close === 'function') {
          overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
        }
      }

      if (sections['main-cart-items']) {
        var pageDoc = parser.parseFromString(sections['main-cart-items'], 'text/html');
        var nextPage = pageDoc.querySelector('.hj-cart-page');
        var currentPage = document.querySelector('.hj-cart-page');
        if (nextPage && currentPage) currentPage.innerHTML = nextPage.innerHTML;
      }

      if (sections['main-cart-footer']) {
        var footerDoc = parser.parseFromString(sections['main-cart-footer'], 'text/html');
        var nextFooter = footerDoc.getElementById('main-cart-footer');
        var currentFooter = document.getElementById('main-cart-footer');
        if (nextFooter && currentFooter) currentFooter.innerHTML = nextFooter.innerHTML;
      }

      updateCartIcon(sections['cart-icon-bubble'], itemCount);
      updateStickyCheckout(sections['havjoy-sticky-checkout'], itemCount);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hj-cart', cartData: cartState,
          renderedSections: Object.keys(sections).filter(function (key) { return !!sections[key]; }) });
      }

      syncSummaryDetails();
    });
  }

  function refreshCart(cartState) {
    var provided = cartState && cartState.sections;
    var required = ['cart-icon-bubble'];
    if (document.querySelector('cart-drawer')) required.push('cart-drawer');
    if (document.querySelector('.hj-cart-page')) required.push('main-cart-items', 'main-cart-footer');
    if (document.getElementById('havjoy-sticky-checkout')) required.push('havjoy-sticky-checkout');
    var complete = provided && required.every(function (key) { return typeof provided[key] === 'string' && provided[key].trim(); });
    var sectionsRequest = complete ? Promise.resolve(provided) : fetch(cartRoot() + 'cart?sections=' + cartSections().join(','))
      .then(function (response) {
        if (!response.ok) throw new Error('Cart sections refresh failed');
        return response.json();
      });
    var hasAuthoritativeCart = cartState && typeof cartState.item_count === 'number';
    var cartRequest = hasAuthoritativeCart
      ? Promise.resolve(cartState)
      : fetch(cartRoot() + 'cart.js').then(function (response) {
        if (!response.ok) throw new Error('Cart state refresh failed');
        return response.json();
      });

    return Promise.all([sectionsRequest, cartRequest]).then(function (results) {
      return renderSections(results[0], results[1]);
    });
  }

  function setCardBusy(card, isBusy) {
    if (!card) return;
    card.classList.toggle('is-updating', isBusy);
    card.setAttribute('aria-busy', String(isBusy));
  }

  function updateLine(lineKey, quantity, card) {
    if (variantReplacementBusy) return Promise.resolve();
    setCardBusy(card, true);

    if (card && card.dataset.cartBusy === 'true') return Promise.resolve();
    if (card) card.dataset.cartBusy = 'true';
    return fetch(cartRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: Math.max(0, quantity), sections: cartSections(), sections_url: window.location.pathname })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    }).then(refreshCart).catch(function (error) {
      console.error('[hj-cart] update failed', error);
      return refreshCart();
    }).finally(function () {
      setCardBusy(card, false);
      if (card) delete card.dataset.cartBusy;
    });
  }

  function getCartLine(lineKey) {
    // Liquid HTML-escapes property values, including placement JSON. Read the
    // authoritative values before matching/removing a line or copying properties.
    return fetch(cartRoot() + 'cart.js', { cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not read your cart. Please try again.');
        return response.json();
      })
      .then(function (cart) {
        var line = cart.items.find(function (item) { return item.key === lineKey; });
        if (!line) throw new Error('Your cart changed. Please try again.');
        return line;
      });
  }

  async function replaceCartVariant(original, replacement) {
    function propertiesKey(properties) {
      var object = Array.isArray(properties) ? Object.fromEntries(properties) : properties || {};
      return JSON.stringify(Object.keys(object).sort().map(function (key) { return [key, object[key]]; }));
    }
    function matching(cart, variantId, properties, plan) {
      return cart.items.filter(function (item) {
        var itemPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id;
        return Number(item.variant_id) === Number(variantId) && propertiesKey(item.properties) === propertiesKey(properties) &&
          String(itemPlan || '') === String(plan || '');
      });
    }
    async function readCart() {
      var response = await fetch(cartRoot() + 'cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error('Could not verify the updated cart.');
      return response.json();
    }
    async function change(item, quantity) {
      var response = await fetch(cartRoot() + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: quantity, sections: cartSections(), sections_url: window.location.pathname })
      });
      if (!response.ok) throw new Error('Could not replace the previous variant.');
      return response.json();
    }
    var plan = original.selling_plan_allocation && original.selling_plan_allocation.selling_plan.id;
    var response = await fetch(cartRoot() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [replacement] })
    });
    if (!response.ok) throw new Error('The selected variant could not be added. Your original item is unchanged.');
    try {
      // Discounts can change every line key after add.js. Never remove by a stale key.
      var cart = await readCart();
      var originals = matching(cart, original.variant_id, original.properties, plan);
      if (!originals.length) return cart;
      if (originals.length !== 1 || originals[0].quantity !== original.quantity) throw new Error('Your cart changed. Please try again.');
      return await change(originals[0], 0);
    } catch (error) {
      // Reconcile an uncertain remove before undoing only the quantity we added.
      var current = await readCart();
      if (!matching(current, original.variant_id, original.properties, plan).length) return current;
      var added = matching(current, replacement.id, replacement.properties, replacement.selling_plan);
      if (added.length === 1 && added[0].quantity >= replacement.quantity) {
        await change(added[0], added[0].quantity - replacement.quantity);
      } else {
        throw new Error('Could not verify the variant replacement. Please review your cart before retrying.');
      }
      throw new Error('Could not replace this variant. Your original item has been kept. Please try again.');
    }
  }

  function changeVariant(lineKey, variantId, card, options) {
    if (variantReplacementBusy) return Promise.resolve();
    if (card && card.dataset.cartBusy === 'true') return Promise.resolve();
    variantReplacementBusy = true;
    if (card) card.dataset.cartBusy = 'true';
    setCardBusy(card, true);
    options = options || {};

    return getCartLine(lineKey, card).then(function (line) {
      if (!line) return;
      if (Number(line.variant_id) === Number(variantId)) return;
      var properties = Object.assign({}, line.properties || {});
      var designUrl = properties.your_design || properties._your_design;
      var prepareProperties = Promise.resolve(properties);
      if (properties._personalization_flow === 'direct_ornament_inputs_v1') {
        prepareProperties = window.HavjoyDesignPreview.directVariant(properties, variantId);
      } else if (properties._personalization_flow === 'ceramic_3d_v1') {
        if(card)card.dataset.helpVi='Đổi Shape sẽ lấy đúng preview và file in từ Design đã chốt. Nếu thiếu preview, Order trong cart được giữ nguyên.';
        prepareProperties = fetch('https://dashboard.havjoy.com/api/product-template-finalize', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({session_id:properties._ceramic_design_id,product_handle:line.handle,variant:String(variantId)})
        }).then(function (response) {
          if (!response.ok) throw new Error('Preview unavailable for this Shape. Your original item has been kept.');
          return response.json();
        }).then(function (result) { return Object.assign({},properties,result.properties); });
      } else if (Object.prototype.hasOwnProperty.call(properties, '_design_preview')) {
        properties = window.HavjoyDesignPreview.selectProperties(properties, variantId, options);
        prepareProperties = Promise.resolve(properties);
      } else if (options.updateMockup && typeof designUrl === 'string' && designUrl) {
        var mockupUrl = findStoredMockup(designUrl, options.productType, options.color).url;
        if (!mockupUrl) throw new Error('Preview unavailable for this option. Your original item has been kept.');
        properties[properties.your_design ? 'your_design' : '_your_design'] = mockupUrl;
      }

      return prepareProperties.then(function (nextProperties) {
        return replaceCartVariant(line, {
          id: Number(variantId), quantity: line.quantity, properties: nextProperties,
          selling_plan: line.selling_plan_allocation && line.selling_plan_allocation.selling_plan.id
        });
      }).then(refreshCart).then(function (result) {
        announceCartUpdate('Product option updated.');
        return result;
      });
    }).catch(function (error) {
      console.error('[hj-cart] variant change failed', error);
      announceCartUpdate(error.message || 'Could not update this product option.');
      return refreshCart();
    }).finally(function () {
      variantReplacementBusy = false;
      setCardBusy(card, false);
      if (card) delete card.dataset.cartBusy;
    });
  }

  function changeOption(select, card) {
    if (!card) return;
    var data = card.querySelector('[data-cart-product-variants]');
    var selects = Array.prototype.slice.call(card.querySelectorAll('[data-action="change-option"]'));
    if (!data || !selects.length) return;
    var variants;
    try { variants = JSON.parse(data.textContent || '[]'); }
    catch (error) { variants = []; }
    var values = selects.map(function (item) { return item.value; });
    var variant = variants.find(function (item) {
      return item && item.available !== false && Array.isArray(item.options) && item.options.every(function (value, index) {
        return String(value) === String(values[index]);
      });
    });
    if (!variant) {
      refreshCart();
      return;
    }
    var productTypeSelect = selects.find(function (item) {
      return normalizeMockupVariantName(item.dataset.optionName) === 'product type';
    });
    var colorSelect = selects.find(function (item) {
      return normalizeMockupVariantName(item.dataset.optionName) === 'color';
    });
    changeVariant(select.dataset.lineKey, variant.id, card, {
      updateMockup: select === productTypeSelect || select === colorSelect,
      productType: productTypeSelect ? productTypeSelect.value : '',
      image: variant.featured_image,
      color: colorSelect ? colorSelect.value : ''
    });
  }

  function setCartOptionOpen(combo, isOpen, focusSelected) {
    if (!combo) return;
    var trigger = combo.querySelector('[data-action="toggle-cart-option"]');
    var list = combo.querySelector('.hj-cart-item__option-list');
    var card = combo.closest('.hj-cart-item');
    combo.classList.toggle('is-open', isOpen);
    combo.classList.remove('opens-up');
    if (card) card.classList.toggle('has-open-option', isOpen);
    if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (list) list.hidden = !isOpen;
    if (isOpen && trigger && list) {
      var boundary = combo.closest('cart-drawer-items') || document.documentElement;
      var boundaryRect = boundary.getBoundingClientRect();
      var triggerRect = trigger.getBoundingClientRect();
      var topLimit = Math.max(0, boundaryRect.top);
      var bottomLimit = Math.min(window.innerHeight, boundaryRect.bottom);
      var menuHeight = Math.min(list.scrollHeight, 220) + 5;
      var spaceBelow = bottomLimit - triggerRect.bottom;
      var spaceAbove = triggerRect.top - topLimit;
      combo.classList.toggle('opens-up', spaceBelow < menuHeight && spaceAbove > spaceBelow);
    }
    if (isOpen && focusSelected && list) {
      var selected = list.querySelector('.hj-cart-item__option-value.is-selected');
      if (selected) selected.focus();
    }
  }

  function closeCartOptionCombos(except, restoreFocus) {
    document.querySelectorAll('[data-cart-option-combo].is-open').forEach(function (combo) {
      if (combo === except) return;
      var trigger = combo.querySelector('[data-action="toggle-cart-option"]');
      setCartOptionOpen(combo, false, false);
      if (restoreFocus && trigger) trigger.focus();
    });
  }

  function selectCartOption(target, card) {
    var combo = target.closest('[data-cart-option-combo]');
    var block = combo && combo.closest('.hj-cart-item__size-block');
    var select = block && block.querySelector('[data-action="change-option"]');
    if (!combo || !select) return;
    var value = target.dataset.value || '';
    var changed = select.value !== value;
    select.value = value;
    var label = combo.querySelector('[data-cart-option-label]');
    if (label) label.textContent = value;
    combo.querySelectorAll('.hj-cart-item__option-value').forEach(function (option) {
      var selected = option === target;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    var trigger = combo.querySelector('[data-action="toggle-cart-option"]');
    setCartOptionOpen(combo, false, false);
    if (trigger) trigger.focus();
    if (changed) changeOption(select, card);
  }

  function toggleDiscount(target) {
    var root = target.closest('[data-discount-collapse]');
    var form = root && root.querySelector('[data-discount-form]');
    if (form) form.hidden = !form.hidden;
  }

  function applyDiscount(target) {
    var root = target.closest('[data-discount-collapse]');
    var input = root && root.querySelector('[data-discount-input]');
    var code = input && input.value ? input.value.trim() : '';
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  }

  document.addEventListener('click', function (event) {
    var target = closestAction(event);
    if (!target) {
      closeCartOptionCombos();
      return;
    }

    var action = target.dataset.action;
    var lineKey = target.dataset.lineKey;
    var card = getLineCard(target);
    var currentQty = getQtyFromCard(card);

    if (action === 'toggle-cart-option') {
      event.preventDefault();
      var combo = target.closest('[data-cart-option-combo]');
      var willOpen = combo && !combo.classList.contains('is-open');
      closeCartOptionCombos(combo);
      setCartOptionOpen(combo, willOpen, false);
      return;
    }

    if (action === 'select-cart-option') {
      event.preventDefault();
      selectCartOption(target, card);
      return;
    }

    closeCartOptionCombos();

    if (action === 'close-cart') {
      event.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
      return;
    }

    if (action === 'remove-item') {
      event.preventDefault();
      updateLine(lineKey, 0, card);
      return;
    }

    if (action === 'qty-inc') {
      event.preventDefault();
      updateLine(lineKey, currentQty + 1, card);
      return;
    }

    if (action === 'qty-dec') {
      event.preventDefault();
      updateLine(lineKey, currentQty - 1, card);
      return;
    }

    if (action === 'toggle-discount') {
      event.preventDefault();
      toggleDiscount(target);
      return;
    }

    if (action === 'apply-discount') {
      event.preventDefault();
      applyDiscount(target);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.dataset.action === 'change-option') {
      event.preventDefault();
      event.stopPropagation();
      changeOption(event.target, getLineCard(event.target));
      return;
    }
    if (event.target.dataset.action !== 'change-variant') return;
    event.preventDefault();
    event.stopPropagation();
    changeVariant(event.target.dataset.lineKey, event.target.value, getLineCard(event.target));
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var combo = event.target.closest('[data-cart-option-combo]');
    if (!combo || !combo.classList.contains('is-open')) return;
    event.preventDefault();
    closeCartOptionCombos(null, true);
  });

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded', syncSummaryDetails);else syncSummaryDetails();
})();
